import { useStaticQuery, graphql } from "gatsby"

export const useTestimonialsQuery = () => {
    const { testimonialsWpPage, testimonialsAllBirdeyedata } = useStaticQuery(
        graphql`
        query TestimonialsQuery {
          testimonialsWpPage: wpPage(title: {eq: "Home"}) {
            testimonials {
              testimonialsBackgroundVideoUrl {
                url
              }
              testimonialsPlayButton {
                localFile {
                  childSvg{
                    content{
                      data
                    }
                  }
                }
              }
              testimonialsFullVideoUrl {
                url
              }
              testimonialsVideoCardContent
              testimonialsHeading
              testimonialsSubheading
              testimonialsH1
              testimonialsContent
              testimonialsH1
              testimonialsLink {
                title
                url
              }
              videoBackgroundImage {
                localFile {
                  childImageSharp {
                    gatsbyImageData
                  }
                }
              }
            }
          }
          testimonialsAllBirdeyedata: allBirdeyedata(
            limit: 10
            filter: {id: {ne: "dummy"}, rating: {gte: 3}, sourceType: {ne: "Direct Feedback"}, comments: {ne: null}}
          ) {
            nodes {
              sourceType
              comments
              reviewer {
                firstName
                lastName
              }
              rating
            }
          }
        }
        `)
return {testimonialsWpPage, testimonialsAllBirdeyedata}
}